/*
 * Mr Link Color
 *
 * Cycles hover background colors for inline links
 *
 */

function applyColors() {
	const links = document.querySelectorAll( 'a' );
	const startOffset = parseInt( document.documentElement.getAttribute( 'data-link-color-offset' ) ?? '0', 10 );

	links.forEach( ( link, i ) => {
		link.setAttribute( 'data-color', ( i + startOffset ) % 4 );
	} );
}

( new MutationObserver( ( mutationList ) => {
	for ( const mutation of mutationList ) {
		if ( mutation.type !== 'childList' ) {
			continue;
		}

		applyColors();
		break;
	}
} ) ).observe( document, {
	attributes: false,
	childList: true,
	subtree: true,
} );

applyColors();
